<template >
  <path :d="d" :fill="fill" :stroke="stroke" :opacity="opacity" />
</template>
<script>
export default {
  name: "Radar",

  computed: {
    d() {
      return (
        this.points.reduce((prev, curr) => {
          const currentX = curr.x;
          const currentY = curr.y;
          if (!prev) {
            prev += `M${currentX},${currentY} `;
          } else {
            prev += `L${currentX},${currentY} `;
          }
          return prev;
        }, "") + "Z"
      );
    },
  },

  props: {
    fill: String,
    opacity: String,
    stroke: String,
    points: Array,
  },
};
</script>